/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClaimResponseSearch } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { SearchClaimResponses200Response } from '../models';
/**
 * FHIRClaimResponseApi - axios parameter creator
 * @export
 */
export const FHIRClaimResponseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search claim responses
         * @summary Search claim responses
         * @param {boolean} includeEraDetails 
         * @param {ClaimResponseSearch} claimResponseSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClaimResponses: async (includeEraDetails: boolean, claimResponseSearch: ClaimResponseSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'includeEraDetails' is not null or undefined
            assertParamExists('searchClaimResponses', 'includeEraDetails', includeEraDetails)
            // verify required parameter 'claimResponseSearch' is not null or undefined
            assertParamExists('searchClaimResponses', 'claimResponseSearch', claimResponseSearch)
            const localVarPath = `/api/v1/fhir/claimResponse/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (includeEraDetails !== undefined) {
                localVarQueryParameter['includeEraDetails'] = includeEraDetails;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimResponseSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRClaimResponseApi - functional programming interface
 * @export
 */
export const FHIRClaimResponseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRClaimResponseApiAxiosParamCreator(configuration)
    return {
        /**
         * Search claim responses
         * @summary Search claim responses
         * @param {boolean} includeEraDetails 
         * @param {ClaimResponseSearch} claimResponseSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchClaimResponses(includeEraDetails: boolean, claimResponseSearch: ClaimResponseSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchClaimResponses200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchClaimResponses(includeEraDetails, claimResponseSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimResponseApi.searchClaimResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRClaimResponseApi - factory interface
 * @export
 */
export const FHIRClaimResponseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRClaimResponseApiFp(configuration)
    return {
        /**
         * Search claim responses
         * @summary Search claim responses
         * @param {FHIRClaimResponseApiSearchClaimResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClaimResponses(requestParameters: FHIRClaimResponseApiSearchClaimResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchClaimResponses200Response> {
            return localVarFp.searchClaimResponses(requestParameters.includeEraDetails, requestParameters.claimResponseSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRClaimResponseApi - interface
 * @export
 * @interface FHIRClaimResponseApi
 */
export interface FHIRClaimResponseApiInterface {
    /**
     * Search claim responses
     * @summary Search claim responses
     * @param {FHIRClaimResponseApiSearchClaimResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimResponseApiInterface
     */
    searchClaimResponses(requestParameters: FHIRClaimResponseApiSearchClaimResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchClaimResponses200Response>;

}

/**
 * Request parameters for searchClaimResponses operation in FHIRClaimResponseApi.
 * @export
 * @interface FHIRClaimResponseApiSearchClaimResponsesRequest
 */
export interface FHIRClaimResponseApiSearchClaimResponsesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FHIRClaimResponseApiSearchClaimResponses
     */
    readonly includeEraDetails: boolean

    /**
     * 
     * @type {ClaimResponseSearch}
     * @memberof FHIRClaimResponseApiSearchClaimResponses
     */
    readonly claimResponseSearch: ClaimResponseSearch
}

/**
 * FHIRClaimResponseApi - object-oriented interface
 * @export
 * @class FHIRClaimResponseApi
 * @extends {BaseAPI}
 */
export class FHIRClaimResponseApi extends BaseAPI implements FHIRClaimResponseApiInterface {
    /**
     * Search claim responses
     * @summary Search claim responses
     * @param {FHIRClaimResponseApiSearchClaimResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimResponseApi
     */
    public searchClaimResponses(requestParameters: FHIRClaimResponseApiSearchClaimResponsesRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimResponseApiFp(this.configuration).searchClaimResponses(requestParameters.includeEraDetails, requestParameters.claimResponseSearch, options).then((request) => request(this.axios, this.basePath));
    }
}

